import React, { Component } from 'react';
import {
  Typography,
  TextField,
  Grid,
  Button,
  Link,
  Paper,
  withStyles,
} from '@material-ui/core';
import { connect } from 'react-redux';
import validator from 'validator';
import { userSignedIn } from '../redux/actions';
import ForgotPassword from './ForgotPassword';
import Info from './Registration/Info';
import CircularProgressIndicator from '../components/CircularProgressIndicator';
import GoHome from '../components/GoHome';
import {
  apiGet,
  apiPost,
  persistUserFromProfile,
  setTokens,
} from '../api/client';

const useStyles = (theme) => ({
  remember: {
    [theme.breakpoints.up('1293')]: {
      transform: 'translateX(-6%)',
    },
  },
});

function mapDispatchToProps(dispatch) {
  return {
    signInUser: (signedIn) => dispatch(userSignedIn(signedIn)),
  };
}

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      invalidEmail: false,
      invalidPassword: false,
      notVerified: false,
      progressIndicator: false,
      forgot: false,
    };

    this.email = this.email.bind(this);
    this.password = this.password.bind(this);
    this.login = this.login.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }

  email(event) {
    this.setState({ email: event.target.value, invalidEmail: false });
  }
  password(event) {
    this.setState({ password: event.target.value, invalidPassword: false });
  }

  login() {
    this.setState({ progressIndicator: true });
    apiPost(
      '/auth/login',
      { email: this.state.email, password: this.state.password },
      { auth: false }
    )
      .then(({ data }) => {
        setTokens(data);
        this.redirectTo();
      })
      .catch((err) => {
        if (err.code === 'email_unverified') {
          this.setState({ progressIndicator: false, notVerified: true });
        } else if (err.status === 401) {
          this.setState({
            progressIndicator: false,
            invalidPassword: true,
          });
        } else {
          this.setState({
            progressIndicator: false,
            invalidEmail: true,
          });
        }
      });
  }

  redirectTo() {
    apiGet('/me')
      .then(({ data: res }) => {
        persistUserFromProfile(res);
        if (!res.address) {
          window.location.href = '/register2';
        } else if (
          localStorage.getItem('createServiceRequestBySearchingProviders')
        ) {
          window.location.href = `/requestprovider/${localStorage.getItem(
            'createServiceRequestBySearchingProviders'
          )}`;
        } else {
          this.props.signInUser(true);
          window.location.href = '/';
        }
      })
      .catch(() => {
        this.setState({ progressIndicator: false, invalidEmail: true });
      });
  }

  render() {
    const { classes } = this.props;
    return localStorage.getItem('accessToken') ||
      localStorage.getItem('ResetToken') ? (
      <GoHome message="You are already logged in" />
    ) : (
      <Paper>
        <CircularProgressIndicator open={this.state.progressIndicator} />
        <Info />
        <Grid
          container
          direction="column"
          style={{
            position: 'absolute',
            top: '20%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '30%',
          }}
        >
          <Typography
            align="center"
            style={{ color: '#8692a6', fontSize: 30, fontWeight: 600 }}
          >
            Login
          </Typography>
          <TextField
            required
            name="Email"
            id="Email"
            type="email"
            variant="outlined"
            margin="dense"
            label="Email"
            value={this.state.email}
            onChange={this.email}
            error={this.state.invalidEmail}
            helperText={
              this.state.invalidEmail ? 'Invalid email or account' : null
            }
          />
          <TextField
            required
            name="Password"
            id="Password"
            type="password"
            variant="outlined"
            margin="dense"
            label="Password"
            value={this.state.password}
            onChange={this.password}
            error={this.state.invalidPassword || this.state.notVerified}
            helperText={
              this.state.invalidPassword
                ? 'Invalid password'
                : this.state.notVerified
                ? 'Please verify your email before signing in'
                : null
            }
          />
          <Grid container justify="space-between" alignItems="center">
            <Button
              style={{ textTransform: 'none' }}
              onClick={() => this.setState({ forgot: true })}
            >
              Forgot Password?
            </Button>
            <Button
              variant="contained"
              style={{
                textTransform: 'none',
                backgroundColor: '#f5802c',
                color: '#FFFFFF',
              }}
              onClick={() => {
                validator.isEmail(this.state.email)
                  ? this.login()
                  : this.setState({ invalidEmail: true });
              }}
            >
              Login
            </Button>
          </Grid>
          <Grid container justify="center" style={{ marginTop: 20 }}>
            <Link href="/register1" style={{ textDecoration: 'none' }}>
              <Typography style={{ color: '#f5802c' }}>
                Create an account
              </Typography>
            </Link>
          </Grid>
        </Grid>
        {this.state.forgot && (
          <ForgotPassword
            email={this.state.email}
            close={() => this.setState({ forgot: false })}
          />
        )}
      </Paper>
    );
  }
}

export default connect(null, mapDispatchToProps)(withStyles(useStyles)(Login));
